var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBymRenhold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "glyphicons-68-cleaning copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24,23.28 L12.48,23.28 L13.44,19.44 L23.04,19.44 L24,23.28 Z M23.04,17.28 C23.04,16.752 22.36896,16.56 21.84096,16.56 L19.2,16.56 L19.2,0.96 C19.2,0.42912 18.76992,0 18.24,0 C17.71008,0 17.28,0.42912 17.28,0.96 L17.28,16.56 L14.16096,16.56 C13.63296,16.56 13.44,16.752 13.44,17.28 L13.44,18.48 L23.04,18.48 L23.04,17.28 Z M12.48,11.40384 C12.48,11.13984 12.264,10.92384 12,10.92384 L0.48,10.92384 C0.216,10.92384 0,11.13984 0,11.40384 L0,12.18336 C0,12.44736 0.216,12.66336 0.48,12.66336 L0.93888,12.66336 L2.35872,21.8496 C2.48064,22.6368 3.17664,23.28 3.9072,23.28 L8.5728,23.28 C9.3024,23.28 9.99936,22.6368 10.12128,21.8496 L11.54112,12.66336 L12,12.66336 C12.264,12.66336 12.48,12.44736 12.48,12.18336 L12.48,11.40384 Z M6.24,6.57024 C8.06016,6.57024 9.55392,7.93344 9.79104,9.69024 L11.23104,9.69024 C10.98528,7.13952 8.85408,5.13024 6.24,5.13024 C3.62592,5.13024 1.49472,7.13952 1.24896,9.69024 L2.68896,9.69024 C2.92608,7.93344 4.41984,6.57024 6.24,6.57024 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "glyphicons-68-cleaning-copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "glyphicons-68-cleaning",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color/Palette/Gray-dark",
    mask: "url(#mask-2)",
    fill: "currentcolor"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "#4D4D4D",
    points: "0 0 24 0 24 24 0 24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBymRenhold);
export default __webpack_public_path__ + "static/media/BYM_Renhold.424ffeb0.svg";
export { ForwardRef as ReactComponent };